import { render, staticRenderFns } from "./InfoPrivateFlow.vue?vue&type=template&id=6264cbde&"
import script from "./InfoPrivateFlow.vue?vue&type=script&lang=js&"
export * from "./InfoPrivateFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6264cbde')) {
      api.createRecord('6264cbde', component.options)
    } else {
      api.reload('6264cbde', component.options)
    }
    module.hot.accept("./InfoPrivateFlow.vue?vue&type=template&id=6264cbde&", function () {
      api.rerender('6264cbde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/components/InfoPrivateFlow.vue"
export default component.exports